module.exports = __webpack_public_path__ + "img/account-setting-icon.e7845267.svg";